import { FC } from "react";
import { toast } from "react-toastify";
import { AddIcon } from "../../assets/img/icons";
import {
    IMAGE_FILE_ACCEPT,
    fileMatchesAccept,
} from "../../utils/fileAccept";

import { REQUIRED_FIELD } from "../../utils/errors";
import Text from "../Text";
import styles from "./styles.module.scss";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
    label?: string;
    onChanged?: (value: any) => void;
    className?: string;
    placeholder?: string;
    error?: string;
    /** Bordure rouge seule (ex. lignes compactes TradeList). */
    showErrorMessage?: boolean;
    min?: string;
    max?: string;
    fileInputId?: string; // ajouts de Tony - ID unique pour les inputs file
    size?: "small" | "medium" | "large";
};

const Input: FC<Props> = ({
    label,
    onChanged,
    className,
    placeholder,
    error,
    showErrorMessage = true,
    min,
    max,
    fileInputId, // ajouts de Tony
    ...props
}) => {
    let additionalProps = {};

    if (props.type === "number") {
        additionalProps = {
            pattern: ",[0-9]*",
        };
    }

    // ajouts de Tony - ID unique pour éviter les conflits entre plusieurs inputs file
    const inputFileId = fileInputId || "input_trade_img";
    // fin ajouts de Tony

    const fileAccept = props.accept ?? IMAGE_FILE_ACCEPT;

    return (
        <div
            className={`${styles.input_container} ${
                className ? className : ""
            }`}
        >
            {label && <Text variant="body-bold">{label}</Text>}
            {props.type === "file" ? (
                <>
                    <label
                        htmlFor={inputFileId}
                        className={`${styles.input} ${styles.input_file}${
                            error ? ` ${styles.inputError}` : ""
                        }`}
                    >
                        <div className={styles.input_file_label_text}>
                            {props.value
                                ? `${props.value}...`
                                : "Choisir un fichier..."}
                        </div>
                        <AddIcon
                            className={styles.input_file_label_icon}
                            width={16}
                        />
                    </label>
                    <input
                        id={inputFileId}
                        type="file"
                        accept={fileAccept}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const input = e.target;
                            const files = input.files;
                            if (!files || files.length === 0) return;

                            const rejected = Array.from(files).find(
                                (file) => !fileMatchesAccept(file, fileAccept)
                            );
                            if (rejected) {
                                toast.error(
                                    `Type de fichier non autorisé (${rejected.name}).`
                                );
                                input.value = "";
                                return;
                            }

                            onChanged?.(files);
                        }}
                    />
                </>
            ) : (
                <input
                    className={`${styles.input}${
                        error ? ` ${styles.inputError}` : ""
                    }`}
                    placeholder={placeholder}
                    aria-invalid={Boolean(error)}
                    {...additionalProps}
                    {...props}
                    onChange={(e) => onChanged && onChanged(e.target.value)}
                    min={min}
                    max={max}
                />
            )}
            {showErrorMessage &&
                error &&
                error !== REQUIRED_FIELD && (
                    <p className={styles.input_error_text}>{error}</p>
                )}
        </div>
    );
};

export default Input;
